import React, { useState, useEffect, useContext } from "react";
import {
  Route,
  Router,
  Routes,
  Switch,
  useLocation,
  useNavigate,
} from "react-router-dom";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import { Button, CircularProgress } from "@material-ui/core";
import { getUserData } from "../Components/Common/Utility/Utils";
import { StoreContext } from "../Store/Provider";
import "./navigation.css";
import apiRoute from "./utils/apiRoutes";
import RestrictedRoutes from "./component/RestrictedRoute";
import ProtectedRoute from "./component/ProtectedRoute";
import { baseURL, LOCAL_STORAGE_KEY, ProjectName } from "../Config";
import { localStoragekey } from "../Components/Common/Utility/Utils";

import { routeConstant } from "./utils/routeConstant";
import Login from "../Components/Screens/Login";
import ShipmentsListing from "../Components/Screens/Home/MainSection/ShipmentsListing/ShipmentsListing";
import Dashboard from "../Components/Screens/dashboard/Dashboard";
import Statement from "../Components/Screens/Statement/Statement";
import Schedule from "../Components/Screens/schedule/Schedule";
import UpdatePassword from "../Components/Screens/UpdatePassword/UpdatePassword";
import ForgotPassword from "../Components/Screens/ForgotPassword/ForgotPassword";
import ResetPassword from "../Components/Screens/ForgotPassword/ResetPassword";
import ScheduleSearchResult from "../Components/Screens/schedule/ScheduleSearchResult/ScheduleSearchResult";
import RequestQuote from "../Components/Screens/schedule/RequestQuote/RequestQuote";
import SearchResults from "../Components/Screens/Home/MainSection/ShipmentsListing/SearchResults";
import AdvSearchResults from "../Components/Screens/Home/MainSection/ShipmentsListing/AdvSearchResults";
import Error from "../Components/Screens/Home/Error";
import Users from "../Components/Screens/Home/users/Users";
import SearchShipment from "../Components/Screens/Home/SearchShipment/SearchShipment";
import LoadingComp from "../Components/Screens/loading/LoadingComp";
import SearchShipmentResult from "../Components/Screens/Home/SearchShipment/SearchShipmentResult";
import BlogSFL from "../Components/Screens/Home/Blog/BlogSFL";
import MapFullView from "../Components/Screens/Home/MainSection/SidebarData/FullMapView";
import OrderReports from "../order_managment/screens/orderReport";
import SystemLog from "../order_managment/screens/systemLog";
import CreateNewOrder from "../order_managment/screens/order/index";
import OrderList from "../order_managment/screens/orderList/index";
import ArchiveOrder from "../order_managment/screens/orderList/component/ArchiveOrder";
import RejectedOrder from "../order_managment/screens/orderList/component/RejectedOrder";
import ShippedOrder from "../order_managment/screens/orderList/component/ShippedOrder";
import ApprovedOrder from "../order_managment/screens/orderList/component/ApprovedOrder";
import PlacedOrder from "../order_managment/screens/orderList/component/PlacedOrder";
import Details from "../order_managment/screens/details/Details";
import OrderDashboard from "../order_managment/screens/dashboard/index";
import MilestoneComponents from "../order_managment/screens/orderList/component/fullDetails/MilestoneComponent";
import OrderSpecific from "../order_managment/screens/order/component/orderCreation/OrderSpecific";
import DocUpload from "../order_managment/screens/order/component/orderCreation/DocUpload";
import Confirmation from "../order_managment/screens/order/component/orderCreation/Confirmation";
import OrderLine from "../order_managment/screens/order/component/orderCreation/OrderLine";
import OrderPlan from "../order_managment/screens/order/component/orderCreation/OrderPlan";
import EditOrderSpecific from "../order_managment/screens/order/component/editOrder/EditOrderSpecific";
import EditOrderLine from "../order_managment/screens/order/component/editOrder/EditOrderLine";
import EditOrderPlan from "../order_managment/screens/order/component/editOrder/EditOrderPlan";
import EditDocUpload from "../order_managment/screens/order/component/editOrder/EditDocUpload";
import EditConfirmation from "../order_managment/screens/order/component/editOrder/EditConfirmation";
import { IsLogin } from "../../src/utils";
import { NotificationManager } from "react-notifications";
import { StoreContext as OmsContext } from "../order_managment/store/index";
import { path } from "../order_managment/constants/apiPath";
import instance from "../order_managment/common/api/interceptor";
import axios from "axios";
import RestrictOrder from "./component/RestrictOrder";
import EnquiryDashboard from "../Components/Screens/enquiryDashboard";
import ArchaiveShipments from "../Components/Screens/Home/MainSection/ShipmentsListing/ArchaiveShipments";

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

function Navigation() {
  const [online, setOnline] = useState(window.navigator.onLine);
  const [openalert, setOpenalert] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const context = useContext(StoreContext);
  const [loading, setLoading] = useState(false);

  const omscontext = useContext(OmsContext);
  const [isMount, setIsMount] = useState(true);

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenalert(false);
  };

  useEffect(async () => {
    if (IsLogin()) {
      const userdata = JSON.parse(
        localStorage.getItem(LOCAL_STORAGE_KEY.user_token)
      );
      if (userdata) {
        getUserDataInfo(userdata.access_token);
      }
      if (location.pathname.includes(routeConstant.CREATE_ORDER_MAIN)) {
        navigate(routeConstant.CREATE_ORDER, { replace: true });
      }
      if (location.pathname === routeConstant.ORDER_LIST) {
        navigate(routeConstant.ORDER_LIST_PLACED, { replace: true });
      }
    } else {
      // navigator(routeConstant.LOGIN);
      setLoading(false);
      setIsMount(true);
    }
    window.addEventListener("offline", () => setOnline(false));
    window.addEventListener("online", () => setOnline(true));
  }, []);
  useEffect(() => {
    !online && setOpenalert(true);
  }, [online]);

  const getUsersAccess = (roles) => {
    setLoading(true);
    instance
      .post(`${path.USER_ACCESS}?roles=${roles}`)
      .then(async (res) => {
        if (res.Is_Success) {
          omscontext.setUserAccess(res.data ?? {});
        } else {
          NotificationManager.error(res.Message, "", 3000);
        }
        setIsMount(true);
        setLoading(false);
      })
      .catch((err) => {
        console.warn(err);
        setLoading(false);
        if (err.response) {
        } else if (err.request) {
        } else if (err.message) {
        } else {
          NotificationManager.error("Something went wrong!", "", 3000);
        }
        setIsMount(true);
      });
  };

  const getUserDataInfo = (token) => {
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    axios
      .post(`${baseURL}${path.USER_DETAILS}`, null, { headers })
      .then(async (res) => {
        if (res.data.Is_Success) {
          context.setOmsUserData(res.data.data ?? {});

          getUsersAccess(res.data.data.DefaultRole);
        } else {
          NotificationManager.error(res.Message, "", 3000);
        }
      })
      .catch((err) => {
        console.warn(err);
        if (err.response) {
        } else if (err.request) {
        } else if (err.message) {
        } else {
          NotificationManager.error("Something went wrong!", "", 3000);
        }
        setIsMount(true);
      });
  };

  useEffect(() => {
    getUserData(localStoragekey)
      .then((res) => {
        context.setIsUserLogin(true);
      })
      .catch((err) => {
        console.log("error section", err);
        context.setIsUserLogin(false);
      });
  }, []);

  if (loading) {
    return (
      <div
        className="d-flex align-item-center justify-content-center"
        style={{ height: "100%" }}
      >
        <CircularProgress />
      </div>
    );
  }

  return (
    <>
      {online ? (
        <Routes>
          <Route
            path={routeConstant.Users}
            element={
              <ProtectedRoute>
                <RestrictedRoutes>
                  <Users />
                </RestrictedRoutes>
              </ProtectedRoute>
            }
          />
          <Route
            path={routeConstant.ScheduleSearchResult}
            element={
              <ProtectedRoute>
                <ScheduleSearchResult />
              </ProtectedRoute>
            }
          />
          <Route
            path={routeConstant.AdvSearchResults}
            element={
              <ProtectedRoute>
                <AdvSearchResults />
              </ProtectedRoute>
            }
          />
          <Route
            path={routeConstant.UpdatePassword}
            element={
              <ProtectedRoute>
                <UpdatePassword />
              </ProtectedRoute>
            }
          />
          <Route
            path={routeConstant.EnquiryDashboard}
            element={
              <ProtectedRoute>
                <EnquiryDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path={routeConstant.Dashboard}
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />

          <Route
            path={routeConstant.ArchaiveShipments}
            element={
              <ProtectedRoute>
                <ArchaiveShipments />
              </ProtectedRoute>
            }
          />

          <Route
            path={routeConstant.Statement}
            element={
              <ProtectedRoute>
                <Statement />
              </ProtectedRoute>
            }
          />

          <Route
            path={routeConstant.ShipmentsListing}
            element={
              <ProtectedRoute>
                <ShipmentsListing />
              </ProtectedRoute>
            }
          />

          <Route
            path={routeConstant.ForgotPassword}
            element={<ForgotPassword />}
          />

          <Route
            path={routeConstant.ResetPassword}
            element={<ResetPassword />}
          />

          <Route path={routeConstant.LoadingComp} element={<LoadingComp />} />

          <Route path={routeConstant.Login} element={<Login />} />

          <Route path={routeConstant.BlogSFL} element={<BlogSFL />} />

          <Route path={routeConstant.Schedule} element={<Schedule />} />

          <Route
            path={routeConstant.SearchResults}
            element={<SearchResults />}
          />

          <Route
            path={routeConstant.SearchShipment}
            element={<SearchShipment />}
          />

          <Route
            path={routeConstant.SearchShipmentResult}
            element={<SearchShipmentResult />}
          />

          <Route path={routeConstant.RequestQuote} element={<RequestQuote />} />

          <Route path={routeConstant.Tracking} element={<MapFullView />} />

          <Route
            path={routeConstant.REPORTS}
            element={
              <ProtectedRoute>
                <RestrictOrder>
                  <OrderReports />
                </RestrictOrder>
              </ProtectedRoute>
            }
          />
          <Route
            path={routeConstant.SYSTEM_LOG}
            element={
              <ProtectedRoute>
                <RestrictOrder>
                  <SystemLog />
                </RestrictOrder>
              </ProtectedRoute>
            }
          />
          <Route
            path={routeConstant.ORDER_LIST}
            element={
              <ProtectedRoute>
                <RestrictOrder>
                  <OrderList />
                </RestrictOrder>
              </ProtectedRoute>
            }
          >
            <Route
              path={routeConstant.ORDER_LIST_PLACED}
              element={<PlacedOrder />}
            />
            <Route
              path={routeConstant.ORDER_LIST_APPROVED}
              element={<ApprovedOrder />}
            />
            <Route
              path={routeConstant.ORDER_LIST_LOADED}
              element={<ShippedOrder />}
            />
            <Route
              path={routeConstant.ORDER_LIST_REJECTED}
              element={<RejectedOrder />}
            />
            <Route
              path={routeConstant.ORDER_LIST_ARCHIVE}
              element={<ArchiveOrder />}
            />
          </Route>
          <Route
            path={routeConstant.ORDER_LIST_FULL}
            element={
              <ProtectedRoute>
                <RestrictOrder>
                  <Details />
                </RestrictOrder>
              </ProtectedRoute>
            }
          />
          <Route
            path={routeConstant.ORDER_LIST_FULL_LOG}
            element={
              <ProtectedRoute>
                <RestrictOrder>
                  <SystemLog />
                </RestrictOrder>
              </ProtectedRoute>
            }
          />
          <Route
            path={routeConstant.ORDER_DASHBOARD}
            element={
              <ProtectedRoute>
                <RestrictOrder>
                  <OrderDashboard />
                </RestrictOrder>
              </ProtectedRoute>
            }
          />
          <Route
            path={routeConstant.DASH_ORDER_LIST_FULL}
            element={
              <ProtectedRoute>
                <RestrictOrder>
                  <Details />
                </RestrictOrder>
              </ProtectedRoute>
            }
          />
          <Route
            path={routeConstant.DASH_ORDER_LIST_FULL_LOG}
            element={
              <ProtectedRoute>
                <RestrictOrder>
                  <SystemLog />
                </RestrictOrder>
              </ProtectedRoute>
            }
          />
          <Route
            path={routeConstant.ORDER_LIST_FULL_MILESTONE_DASH}
            element={
              <ProtectedRoute>
                <RestrictOrder>
                  <MilestoneComponents />
                </RestrictOrder>
              </ProtectedRoute>
            }
          />

          <Route
            path={routeConstant.CREATE_ORDER}
            element={
              <ProtectedRoute>
                <RestrictOrder>
                  <OrderSpecific />
                </RestrictOrder>
              </ProtectedRoute>
            }
          />
          <Route
            exact
            path={routeConstant.LINE_DETAIL}
            element={
              <ProtectedRoute>
                <RestrictOrder>
                  <OrderLine />
                </RestrictOrder>
              </ProtectedRoute>
            }
          />
          <Route
            exact
            path={routeConstant.ORDER_PLAN}
            element={
              <ProtectedRoute>
                <RestrictOrder>
                  <OrderPlan />
                </RestrictOrder>
              </ProtectedRoute>
            }
          />
          <Route
            exact
            path={routeConstant.CONFIRMATION}
            element={
              <ProtectedRoute>
                <RestrictOrder>
                  <Confirmation />
                </RestrictOrder>
              </ProtectedRoute>
            }
          />
          <Route
            exact
            path={routeConstant.DOC_UPLOAD}
            element={
              <ProtectedRoute>
                <RestrictOrder>
                  <DocUpload />
                </RestrictOrder>
              </ProtectedRoute>
            }
          />
          <Route
            exact
            path={routeConstant.EDIT_CREATE_ORDER}
            element={
              <ProtectedRoute>
                <RestrictOrder>
                  <EditOrderSpecific />
                </RestrictOrder>
              </ProtectedRoute>
            }
          />

          <Route
            exact
            path={routeConstant.EDIT_LINE_DETAIL}
            element={
              <ProtectedRoute>
                <RestrictOrder>
                  <EditOrderLine />
                </RestrictOrder>
              </ProtectedRoute>
            }
          />
          <Route
            exact
            path={routeConstant.EDIT_ORDER_PLAN}
            element={
              <ProtectedRoute>
                <RestrictOrder>
                  <EditOrderPlan />
                </RestrictOrder>
              </ProtectedRoute>
            }
          />
          <Route
            exact
            path={routeConstant.EDIT_DOC_UPLOAD}
            element={
              <ProtectedRoute>
                <RestrictOrder>
                  <EditDocUpload />
                </RestrictOrder>
              </ProtectedRoute>
            }
          />
          <Route
            exact
            path={routeConstant.EDIT_CONFIRMATION}
            element={
              <ProtectedRoute>
                <RestrictOrder>
                  <EditConfirmation />
                </RestrictOrder>
              </ProtectedRoute>
            }
          />
          <Route
            path={routeConstant.LIST_EDIT_CREATE_ORDER}
            element={
              <ProtectedRoute>
                <RestrictOrder>
                  <EditOrderSpecific />
                </RestrictOrder>
              </ProtectedRoute>
            }
          />

          <Route
            path={routeConstant.ORDER_LIST_FULL_MILESTONE}
            element={
              <ProtectedRoute>
                <RestrictOrder>
                  <MilestoneComponents />
                </RestrictOrder>
              </ProtectedRoute>
            }
          />

          <Route path={"*"} element={<Error />} />
        </Routes>
      ) : (
        <div className="noInternet">
          <img
            src={`/${ProjectName}/Assets/Images/SFL_Logo_Secondary.png`}
            alt="company Logo"
          />
          <p>Connect to the internet</p>
          <p>You're offline. Check your connection.</p>
          <Button onClick={() => window.location.reload()}>RETRY</Button>
        </div>
      )}
    </>
  );
}

export default Navigation;
